import {Component, OnInit} from '@angular/core';
import {ConfirmationService, MessageService} from "primeng/api";
import {CommissionsService} from "projects/store/src/app/services/api/v1/commissions.service";
import {CustomMessageService, LocalStorageService, ResponseHttpSuccess, ResponseHttpError, UtilService} from "library";
import {HttpStatusCode} from "@angular/common/http";
import {UserData} from "projects/store/src/app/interfaces";
import {LocalStorageKey} from "projects/store/src/app/enums";
import {environment} from "projects/store/src/environments/environment";

@Component({
  selector: 'app-commission-payments',
  templateUrl: './commission-payments.component.html',
  providers: [ConfirmationService]
})
export class CommissionPaymentsComponent implements OnInit{
  labelBreadcrumb = 'Estado de pagos'
  commissions: any[] = [];
  listCommissionsAcumulated: any;
  visible: boolean = false;
  confirmVisible: boolean = false;
  userData: UserData;
  requestPaymentStatus!: boolean;

  constructor(private confirmationService: ConfirmationService,
              private messageService: MessageService,
              private customMessageService: CustomMessageService,
              private commissionsService: CommissionsService,
              private utilService: UtilService,
              private localStorageService: LocalStorageService) {
    this.userData = this.localStorageService.get(LocalStorageKey.data)
  }

  ngOnInit() {
    this.load();
    this.loadAcumulated(this.userData.user.id);
  }

  load() {
    this.utilService.enablePageLoading();
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();
    this.commissionsService.getCommisionsOfUser(this.userData.user.id, month, year).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok){
          this.commissions = resp.body.data.list.slice(0, 5);
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    })

    this.commissionsService.getRequestPaymentStatus(this.userData.user.id).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok){
          this.requestPaymentStatus = resp.body.data.open;
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
      }
    });
  }

  loadAcumulated(id: string){
    this.utilService.enablePageLoading();
    this.commissionsService.getCommisionsAcumulatedOfUser(id).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok){
          this.listCommissionsAcumulated = resp.body.data.accumulated_commissions;
          console.log(this.listCommissionsAcumulated);
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
      }
    })
  }

  confirmRequestPayment(){
    // this.confirmationService.confirm({
    //   message: 'Esta seguro que desea solicitar el pago?',
    //   header: 'Confirmación',
    //   icon: 'pi pi-exclamation-triangle',
    //   accept: () => {
    //     this.requestPayment();
    //   },
    // })
    this.confirmVisible = true;
  }
  requestPayment(){
    this.utilService.enablePageLoading();
    this.commissionsService.sendRequestPaymentOfCommissions(this.userData.user.id).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Created){
          this.load();
          this.loadAcumulated(this.userData.user.id);
          this.visible = true;
        } else{
          this.customMessageService.responseNoticeHandler(resp)
        }
        this.utilService.disablePageLoading();
      }
    });
  }

    protected readonly environment = environment;
}



